import React from "react";
import Pending from "./pending";
import File from "./file";
import Download from "./download";

const Messages = React.memo(() => {
  return (
    <div>
      <Pending />
      <File />
      <Download />
    </div>
  );
});

export default Messages;
